const getDefaultState = () => {
  return {
    // token: getToken(),
    advertiserId: "", // 账号ID
    ttUserId: "",
  };
};

const state = getDefaultState();

const mutations = {
  SET_ADVERTISERID: (state, advertiserId) => {
    state.advertiserId = advertiserId;
  },
  SET_TTUSERID: (state, ttUserId) => {
    state.ttUserId = ttUserId;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
